/* ================================================================
   CommonGoods — Auto Table of Contents (Daftar Isi)
   File: assets/cg-article-toc.js

   Otomatis membuat kotak "Daftar Isi" di setiap artikel blog dari
   heading <h2> yang ada di body artikel. Tidak perlu edit tiap post.

   - Styling memakai class .article-toc di assets/cg-blog.css
   - Heading tanpa id akan diberi id otomatis (untuk anchor link)
   - Kalau artikel sudah punya <nav class="article-toc"> manual,
     script ini TIDAK menimpa (skip) supaya tidak dobel.
   ================================================================ */
(function () {
  'use strict';

  // Minimal jumlah heading agar TOC layak ditampilkan.
  var MIN_HEADINGS = 3;

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9À-ɏ\s-]/g, '') // buang simbol, sisakan huruf/angka
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '') || 'bagian';
  }

  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content) return;

    // Jangan buat dobel jika artikel sudah punya TOC manual.
    if (content.querySelector('.article-toc')) return;

    // Ambil h2 di dalam artikel, kecuali yang berada di dalam widget
    // (carousel produk, sidebar, atau TOC itu sendiri).
    var headings = Array.prototype.filter.call(
      content.querySelectorAll('h2'),
      function (h) {
        return !h.closest('.article-toc') &&
               !h.closest('.cg-products-block') &&
               !h.closest('.cg-blog-sidebar') &&
               h.textContent.trim().length > 0;
      }
    );

    if (headings.length < MIN_HEADINGS) return;

    var usedIds = {};
    var items = headings.map(function (h) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        var base = id, n = 2;
        while (usedIds[id] || document.getElementById(id)) {
          id = base + '-' + n++;
        }
        h.id = id;
      }
      usedIds[id] = true;
      return { id: id, text: h.textContent.trim() };
    });

    // Bangun markup TOC.
    var nav = document.createElement('nav');
    nav.className = 'article-toc';
    nav.setAttribute('aria-label', 'Daftar Isi');

    var title = document.createElement('h2');
    title.textContent = 'Daftar Isi';
    nav.appendChild(title);

    var ol = document.createElement('ol');
    items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.text;
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(ol);

    // Sisipkan sebelum heading pertama (setelah paragraf intro).
    var firstHeading = headings[0];
    firstHeading.parentNode.insertBefore(nav, firstHeading);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
